import { IsProductOutOfStockParams, ValidateStockAmountParams } from './types/stockValidation.types';

type StockStatusCheckParams = {
  productStock: number;
  productMinQuantity: number;
  productInventoryTracked: string;
  productInventoryAllowBackorders: string;
  productInventoryStatus: string;
};

export const checkWhetherProductIsOutOfStock = ({
  productStock,
  productMinQuantity,
  productInventoryTracked,
  productInventoryAllowBackorders,
  productInventoryStatus,
}: StockStatusCheckParams): boolean => {
  // if allowBackorders is not no, then the product is never out of stock
  if (productInventoryAllowBackorders !== 'no') {
    return false;
  }

  if (productInventoryTracked === 'yes') {
    if (productStock <= 0 || (productMinQuantity > 0 && productStock < productMinQuantity)) {
      return true;
    }
  } else if (productInventoryStatus === 'outofstock') {
    return true;
  }

  return false;
};

export const validateStockAmount = ({
  productQuantity,
  product,
  cartItemId,
  hasVariations,
  handleStockError,
}: ValidateStockAmountParams): void => {
  let inventoryData = product?.productInventory;
  let productId = product?.id;
  let productMinQuantity = product?.productMinQuantity;

  if (hasVariations) {
    const data = product?.variations?.find((p) => p?.id === cartItemId);
    productId = data?.id;
    inventoryData = data?.inventory;
    productMinQuantity = data?.productMinQuantity;
  }

  const productStock = inventoryData?.productStock;
  const productInventoryTracked = inventoryData?.productInventoryTracked;
  const productInventoryAllowBackorders = inventoryData?.productInventoryAllowBackorders;
  const productInventoryStatus = inventoryData?.productInventoryStatus;

  const isOutOfStock = checkWhetherProductIsOutOfStock({
    productStock,
    productMinQuantity,
    productInventoryTracked,
    productInventoryAllowBackorders,
    productInventoryStatus,
  });

  if (isOutOfStock) {
    handleStockError((prev) =>
      prev.some((p) => p.productId === productId) ? prev : [...prev, { productId, message: `Out of stock` }]
    );
    return;
  }

  if (productInventoryAllowBackorders === 'no' && productInventoryTracked === 'yes') {
    const showWarningAmount = productStock - 1;
    if (productQuantity >= showWarningAmount) {
      handleStockError((prev) =>
        prev.some((p) => p.productId === productId)
          ? prev
          : [...prev, { productId, message: `Only ${productStock} available` }]
      );
    }
  }
};

export const isProductOutOfStock = ({ product }: IsProductOutOfStockParams): boolean => {
  const productStock = product?.inventory?.productStock;
  const productMinQuantity = product?.attributes?.productMinQuantity;
  const productInventoryStatus = product?.inventory?.productInventoryStatus;
  const productInventoryTracked = product?.inventory?.productInventoryTracked;
  const productInventoryAllowBackorders = product?.inventory?.productInventoryAllowBackorders;

  return checkWhetherProductIsOutOfStock({
    productStock,
    productMinQuantity,
    productInventoryTracked,
    productInventoryAllowBackorders,
    productInventoryStatus,
  });
};
